import React from 'react';

import './LabeledRow.css';
import { formatCurrency } from '../../Currency';


function formatValue(value, isCurrency = false) {
  return isCurrency ? formatCurrency(value) : value;
}


const Component = props => (
  <div styleName={props.modifiedStyle || 'labeledRow'}>
    <div styleName="label">
      { props.label }
    </div>
    <div styleName="value">
      { formatValue(props.value, props.isCurrency)}
    </div>
  </div>
);

Component.displayName = 'LabeledRow';

export default Component;



// WEBPACK FOOTER //
// ./src/components/ExternalInvest/components/LabeledRow.js